import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false; // we don't want to detach/store any routes
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false; // we don't restore anything
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    //  force reload only for digital-signature route
    if (
      curr.routeConfig?.path === 'digital-signature' &&
      future.routeConfig?.path === 'digital-signature'
    ) {
      return false; // don't reuse → forces Angular to recreate component
    }

    //  for all other routes → use default behavior
    return future.routeConfig === curr.routeConfig;
  }
}
